import '@beyonk/gdpr-cookie-consent-banner/dist/browser/bundle'
import '@beyonk/gdpr-cookie-consent-banner/dist/style.css'
import { cookieSettings } from "./cookie/settings";

window.GdprConsent.attachBanner(document.body, cookieSettings)

jQuery(document).ready(($) => {
  /*
    Removes the search icon on input, due to the native X icon
   */
  $('.search-icon input').on('input', function () {
    if ($(this).val() !== "") {
      $('.search-icon').addClass("has-value")
    } else {
      $('.search-icon').removeClass("has-value")
    }
  })


  /**
   * Nav toggle
   */
  $('.nav-toggle').click(function () {
    window.scrollTo(0,0);
    $('body').toggleClass('menu-is-open');
    $('.nav-primary').toggleClass('is-collapsed').fadeToggle();
  });

  /**
   * Sub menu toggle on mobile device
   */
  $('.sub-menu-toggle').click(function () {
    $(this).parent().find('.sub-menu').slideToggle();
  });

  /**
   * Trainingen toggle
   */
  $('.training-table .show-all-items').click(function (e) {
    // e.preventDefault();
    const elements = $(this).parent().parent().find('.show-first');
    console.log(elements);
    if (elements.length > 0) {
      $(elements).toggleClass('show-first').addClass('show-all');
      $(this).addClass('collapsed');
    } else {
      const showAllElements = $(this).parent().parent().find('.show-all');
      showAllElements.toggleClass('show-all').addClass('show-first');
      $(this).removeClass('collapsed');
    }
  });

  /**
   * Training detail form toggle
   */
  $('.toggle-form').click(function () {
    $('#trainingDescription').toggleClass('show');
    $('#trainingForm').toggleClass('show');
    if ($('.toggle-form').hasClass('d-block')) {
      $('.toggle-form').toggleClass('d-block').hide();
    } else {
      $('.toggle-form').toggleClass('d-inline-block').hide();
    }
  });

  $('.banner-slider').slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1300,
    autoplaySpeed: 5000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true
  })

  /**
   * Image slider with slick
   */
  $('.partners-slider').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 7,
    slidesToScroll: 2,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  /**
   * Image slider with slick
   */
  $('.news-slider').slick({
    arrows: false,
    dots: false,
    infinite: false,
    speed: 600,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.hero-images'
  });

  $('.hero-images').slick({
    arrows: false,
    dots: false,
    infinite: false,
    speed: 600,
    // autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false
  })
});

const styles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#EDEDED"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
]

function initMap() {
  const el = document.getElementById('google-map');
  const lat = el.getAttribute('data-lat');
  const lng = el.getAttribute('data-lng');
  const html = el.getAttribute('data-content');
  const title = el.getAttribute('data-title');

  const map = new google.maps.Map(el, {
    fullscreenControl: false, // toggling between street/map view in fullscreen not resolved
    zoom: 15,
    center: {lat: parseFloat(lat), lng: parseFloat(lng)},
    draggableCursor: 'crosshair',
    mapTypeControl: false,
    styles: styles
  });

  const infowindow = new google.maps.InfoWindow({
    content: html
  });

  const marker = new google.maps.Marker({
    position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
    map: map,
    title: title,
    icon: {
      url: window.local_app_object.marker_path,
      labelOrigin: new google.maps.Point(75, 15)
    },
    label: {
      text: title,
      color: "#1762AB",
      fontSize: '16px',
      fontWeight: '500'
    },
  });

  marker.addListener("click", function() {
    infowindow.open(map, marker);
  });
}

window.initMap = initMap

function initGrossiersMap() {
  const elements = document.querySelectorAll('.google-map');
  elements.forEach(element => {
    const lat = parseFloat(element.getAttribute('data-lat'));
    const lng = parseFloat(element.getAttribute('data-lng'));
    const title = element.getAttribute('data-title');

    const map = new google.maps.Map(element, {
      fullscreenControl: false, // toggling between street/map view in fullscreen not resolved
      zoom: 15,
      center: { lat: lat, lng: lng },
      draggableCursor: 'crosshair',
      mapTypeControl: false,
      styles: styles,
      disableDefaultUI: true
    });

    new google.maps.Marker({
      position: new google.maps.LatLng(lat, lng),
      map: map,
      title: title,
      icon: {
        url: window.local_app_object.marker_path,
        labelOrigin: new google.maps.Point(75, 15)
      },
      // label: {
      //   text: title,
      //   color: "#1762AB",
      //   fontSize: '16px',
      //   fontWeight: '500'
      // },
    });
  })
}

window.initGrossiersMap = initGrossiersMap
